import { getSession } from '../modules/Auth/providers/services/authSupabase'
import { REACT_APP_NOTIFIER_API_URL } from '../config/settings/environment'
import { toUserFacingError } from '../config/resources/errors'
import { getLogger } from '../core/debuggers'

const logger = getLogger('notifier.js')

const resolveBaseUrl = () => {
  const base = (REACT_APP_NOTIFIER_API_URL || '').replace(/\/$/, '')
  if (!base) {
    throw new Error(
      'REACT_APP_NOTIFIER_API_URL no está configurada. No podemos generar el cálculo todavía.'
    )
  }
  return base
}

/**
 * Triggers single-user pension calculation on the notifier API.
 * Path is `/sender/send-user` (host `api.*` is the API root).
 * Local: `REACT_APP_NOTIFIER_API_URL=http://127.0.0.1:3001`
 * @returns {Promise<{ status: string }>} `ok` | `already_exists` | `updated` | `frozen_paid` | …
 */
export async function triggerPensionCalculationForCurrentUser() {
  const baseUrl = resolveBaseUrl()
  const { session, error: sessionError } = await getSession()

  if (sessionError) throw sessionError
  if (!session?.access_token) {
    throw new Error('Sesión no disponible. Vuelve a iniciar sesión.')
  }

  let response
  try {
    // Host api.* is the API root — path is /sender/..., not /api/sender/...
    response = await fetch(`${baseUrl}/sender/send-user`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
    })
  } catch (err) {
    logger.error('send-user network error', err)
    throw new Error(
      toUserFacingError(
        err,
        'No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo en unos segundos.'
      )
    )
  }

  let body = null
  try {
    body = await response.json()
  } catch {
    body = null
  }

  if (!response.ok) {
    const rawMessage =
      body?.error || `No pudimos generar tu cálculo (${response.status})`
    logger.error('send-user failed', { status: response.status, body })
    throw new Error(
      toUserFacingError(
        rawMessage,
        'No pudimos generar tu cálculo ahora. Inténtalo de nuevo en unos minutos.'
      )
    )
  }

  return body
}
